<template>
    <div class="col-2" style="min-width:190px;">
        <div class="card shoplist">
            <slot v-if="product.img">
                <img :src="product.img" :alt="product.name" class="card-img-top" />
            </slot>
            <slot v-if="!product.img">
                <div
                    class="d-flex align-content-center justify-content-center text-center"
                    style="height:107px; width:100%; background:#fafafa"
                >
                    <i
                        class="fas fa-image fa-lg d-flex align-self-center"
                        style="font-size:80px; color:#eeeeee"
                    ></i>
                </div>
            </slot>
            <div class="card-body">
                <h5 class="card-title text-center">{{ product.name }}</h5>
            </div>
            <div class="card-footer">
                <div class="card-text mb-2 d-flex">
                    <small class="flex-fill">
                        <span class="text-muted text-uppercase">{{ product.sku }}</span>
                    </small>
                    <small class="flex-fill text-right">
                        <b>{{ product.price | dollars }}</b>
                    </small>
                </div>
                <div class="card-text text-center">
                    <slot v-if="isCanon">
                        <a
                            v-if="showButton(product,'early_kit')"
                            href
                            class="badge badge-success text-uppercase text-white p-1 mb-2 d-block"
                            @click.prevent="addToCart(product, 2)"
                        >
                            <i class="fas fa-cart-plus"></i>
                            {{$t('part.earlykit')}}
                        </a>
                        <a
                            v-if="showButton(product,'canabalizacao')"
                            href
                            class="badge badge-dark text-uppercase text-white p-1 mb-2 d-block"
                            @click.prevent="addToCart(product, 3)"
                        >
                            <i class="fas fa-cart-plus"></i>
                            {{$t('part.cannibalization')}}
                        </a>
                    </slot>
                    <slot v-if="showButton(product,'buy')">
                        <a
                            href
                            class="badge badge-primary text-uppercase p-2"
                            @click.prevent="addToCart(product, null)"
                        >
                            <i class="fas fa-cart-plus"></i> {{$t('part.button.addtocart')}}
                        </a>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { dollars } from "@/helpers/filters";

export default {
  name: "item",
  props: ["product"],
  filters: {
    dollars
  },
  computed: {
    isCanon() {
      return this.$store.getters["auth/getIsCanon"];
    },
    roles() {
      return this.$store.getters["auth/getSessionRoles"];
    }
  },
  methods: {
    // addToCart(product) {
    //   let inv_type = null;
    //   if (this.isCanon) {
    //     inv_type = 2;
    //   }
    //   this.$store.dispatch("cart/addToCart", { product, inv: inv_type });
    // },
    addToCart(product, inv) {
      this.$store.dispatch("cart/addToCart", { product, inv });
    },
    showButton(item, type) {
      return this.roles.some(r => {
        let role = r.replace("-", "_");

        if (role.includes("asf")) {
          role = "asf";
        }

        if (
          item.visible &&
          item.visible.user &&
          item.visible.user[role] !== undefined
        ) {
          try {
            return item.visible.user[role].page["requests"].buttons.includes(
              type
            );
          } catch (e) {
            return false;
          }
        }
        // return item.visible.user[r].page["repair_status"].includes(type);
      });
    }
  }
};
</script>
